import { useQueryClient } from "@tanstack/react-query";
import { Cliente } from "../../../../services/Cliente";

/**
 * Maior que DEFAULT_PAGE_SIZE (5): usado tanto na pré-carga inicial (nome vazio,
 * via `defaultOptions` do AsyncSimpleSelectV2) quanto nas buscas subsequentes,
 * para exibir ao menos 10 concessionárias assim que o campo aparece.
 */
const CONCESSIONARIA_BUSCA_SIZE = 10;

export const useConcessionariaBusca = () => {
  const queryClient = useQueryClient();

  const buscarConcessionarias = (nome: string) => {
    return queryClient
      .fetchQuery({
        queryKey: ["concessionaria-busca", nome],
        queryFn: () =>
          Cliente.getConcessionarias({
            nome,
            page: 0,
            size: CONCESSIONARIA_BUSCA_SIZE,
          }),
      })
      .then(({ data }) => data);
  };

  return { buscarConcessionarias };
};
